{
  "flame": {
    "title": "Llama del Amor",
    "currentStreakLabel": "RACHA ACTUAL",
    "streakDays_one": "{{count}} día seguido",
    "streakDays_many": "{{count}} días seguidos",
    "streakDays_other": "{{count}} días seguidos",
    "status": {
      "firstDay": "Haz tu primera práctica y enciende la Llama",
      "atRisk": "Hoy todavía no has hecho tu práctica",
      "milestone": "¡Nuevo hito alcanzado!",
      "done": "La práctica de hoy está hecha",
      "neutral": "Cuida la Llama con la práctica de hoy"
    },
    "statusLost_one": "La Llama se apagó · mejor racha {{count}} día",
    "statusLost_many": "La Llama se apagó · mejor racha {{count}} días",
    "statusLost_other": "La Llama se apagó · mejor racha {{count}} días",
    "nextMilestone": {
      "label": "Siguiente hito",
      "remaining_one": "queda {{count}} día",
      "remaining_many": "quedan {{count}} días",
      "remaining_other": "quedan {{count}} días",
      "fallbackName_one": "{{count}} día",
      "fallbackName_many": "{{count}} días",
      "fallbackName_other": "{{count}} días"
    },
    "cta": {
      "practice": "Hacer la práctica",
      "relight": "Encender la Llama de nuevo"
    },
    "risk": {
      "title": "La Llama está en riesgo",
      "subtitle": "Hoy todavía no ha habido práctica: la Llama puede apagarse antes de medianoche."
    },
    "success": {
      "done": "Práctica hecha",
      "milestone": "Nuevo hito alcanzado",
      "subtitle": "La Llama del Amor está protegida hasta mañana"
    },
    "a11y": {
      "info": "¿Qué es la Llama del Amor?",
      "share": "Compartir la Llama del Amor",
      "practice": "Hacer la práctica",
      "art": "Llama del Amor"
    },
    "state": {
      "loadingA11y": "Cargando la Llama del Amor",
      "errorMessage": "No pudimos cargar la Llama del Amor. Inténtalo de nuevo.",
      "retry": "Reintentar",
      "retryA11y": "Reintentar la carga de la Llama del Amor"
    }
  },
  "flameInfo": {
    "title": "¿Qué es la Llama del Amor?",
    "intro": "La Llama del Amor es tu racha: muestra cuántos días seguidos mantienes la conexión contigo a través de la práctica.",
    "close": "Cerrar",
    "scrimA11y": "Cerrar la explicación sobre la Llama del Amor",
    "eyebrowLost": "RACHA PERDIDA",
    "share": "Compartir",
    "shareA11y": "Compartir la Llama del Amor",
    "brandTitle": "LLAMA DEL AMOR",
    "streakLabel": "días seguidos",
    "dayUnit": "día",
    "allMilestonesReached": "Todos los hitos alcanzados",
    "milestoneReached": "Siguiente hito alcanzado",
    "progressLabelA11y": "Progreso hacia el siguiente hito",
    "rows": {
      "days": {
        "title": "Días seguidos",
        "description": "Cuántos días seguidos has hecho al menos una práctica. Basta con una acción al día para mantener la racha."
      },
      "flame": {
        "title": "La Llama",
        "description": "El símbolo de tu racha. Mientras practiques cada día, la Llama arde. Si te saltas un día, empieza a apagarse."
      },
      "next": {
        "title": "Siguiente hito",
        "description": "Cada hito es un punto importante en tu camino. Alcánzalos para conseguir logros y recompensas.",
        "allDone": "Todos los hitos disponibles están alcanzados."
      },
      "milestone": {
        "titleFallback": "Siguiente hito",
        "description": "El nombre del siguiente hito en tu camino. Muestra en qué etapa está tu hábito."
      },
      "remaining": {
        "title_one": "Queda {{count}} día",
        "title_many": "Quedan {{count}} días",
        "title_other": "Quedan {{count}} días",
        "reached": "Siguiente hito alcanzado",
        "description": "Cuántos días faltan para el siguiente hito. Sigue tu progreso y acércate a él."
      },
      "progress": {
        "title": "Progreso ({{percent}}%)",
        "description": "Muestra cuánto has avanzado hacia el siguiente hito. Cuantos más días, más cerca está la recompensa."
      }
    },
    "status": {
      "firstDay": {
        "title": "La Llama aún no está encendida",
        "description": "Haz tu primera práctica hoy para encender tu fuego."
      },
      "atRisk": {
        "title": "La Llama está en riesgo",
        "description": "Hoy todavía no ha habido práctica: la Llama puede apagarse antes de medianoche."
      },
      "done": {
        "title": "¡Práctica hecha!",
        "description": "La Llama del Amor está protegida hasta mañana."
      },
      "milestone": {
        "title": "¡Nuevo hito alcanzado!",
        "description": "La Llama del Amor está protegida y ya se ha abierto una nueva recompensa."
      },
      "neutral": {
        "title": "La Llama arde",
        "description": "Practica hoy para mantener el fuego y conservar tu racha."
      },
      "lost": {
        "title": "La Llama se apagó",
        "description": "El contador de días volvió a cero: el camino hacia el siguiente hito empieza de nuevo. La Luz del Alma se conserva."
      }
    },
    "a11y": {
      "flameLost": "La Llama del Amor se apagó",
      "flameBurning": "La Llama del Amor arde"
    }
  },
  "achievements": {
    "title": "Logros",
    "summaryTitle": "Tus logros",
    "summaryCounter": "{{earned}} de {{total}}",
    "summarySubtitle": "Sigue tu camino y desbloquea nuevas insignias.",
    "tabs": {
      "earned": "Obtenidos",
      "inProgress": "En proceso",
      "future": "Próximos"
    },
    "status": {
      "earned": "Obtenido",
      "earnedAt": "Obtenido el {{date}}",
      "progress": "Progreso: {{current}}/{{target}}",
      "inProgress": "En proceso",
      "locked": "Aún sin desbloquear"
    },
    "reward": {
      "title": "Recompensa por el logro",
      "line1": "La insignia se añade a tu colección.",
      "line2": "No se otorga XP adicional."
    },
    "empty": {
      "earned": "Aún no tienes logros. Los primeros aparecerán tras pasos importantes en el Camino de Luz.",
      "inProgress": "Ahora mismo no hay logros en proceso. Empieza a practicar para acercarte al siguiente hito.",
      "future": "Ya has desbloqueado todos los logros disponibles."
    },
    "a11y": {
      "back": "Atrás",
      "info": "¿Qué son los logros?",
      "tab": "{{label}}, {{count}}",
      "card": "{{name}}. {{condition}}. {{status}}"
    },
    "state": {
      "loadingA11y": "Cargando los logros",
      "errorTitle": "No se pudieron cargar los logros",
      "errorMessage": "Inténtalo de nuevo.",
      "offlineTitle": "Sin conexión",
      "offlineMessage": "Los logros aparecerán cuando vuelva la conexión.",
      "retry": "Reintentar",
      "retryA11y": "Reintentar la carga de los logros"
    },
    "unknown": {
      "name": "Logro desconocido",
      "description": "Aparecerá cuando actualices la aplicación."
    }
  },
  "achievementsInfo": {
    "title": "¿Qué son los logros?",
    "intro": "Los logros son los hitos importantes de tu camino. Marcan tus avances, te inspiran a seguir adelante y hacen el camino más consciente y alegre.",
    "close": "Cerrar",
    "scrimA11y": "Cerrar la explicación de los logros",
    "rows": {
      "earned": {
        "title": "Obtenidos",
        "description": "Insignias que ya has desbloqueado."
      },
      "inProgress": {
        "title": "En proceso",
        "description": "Logros hacia los que avanzas ahora mismo."
      },
      "future": {
        "title": "Próximos",
        "description": "Logros que todavía no has empezado."
      }
    },
    "reward": "Cada logro otorga una insignia; no se añade XP adicional."
  },
  "soulLightInfo": {
    "title": "¿Qué es la Luz del Alma?",
    "intro": "La Luz del Alma es la experiencia que refleja tu actividad y tu progreso en la plataforma.",
    "close": "Cerrar",
    "scrimA11y": "Cerrar la explicación de la Luz del Alma",
    "note": "En esta etapa la XP muestra tu progreso y no se gasta.",
    "unavailable": "Los datos de progreso aún no se han cargado.",
    "rows": {
      "currentXp": {
        "title": "XP actual",
        "description": "Muestra cuánta experiencia has acumulado.",
        "value": "{{xp}} XP"
      },
      "nextLevel": {
        "title": "Siguiente nivel",
        "description": "Ahora avanzas hacia el nivel «{{level}}».",
        "unknown": "El siguiente nivel se abrirá a medida que crezcas.",
        "max": "Estás en el nivel máximo."
      },
      "progress": {
        "title": "Progreso — {{percent}} %",
        "titlePlain": "Progreso",
        "description": "Te faltan {{remaining}} XP para el siguiente nivel.",
        "max": "Ya has abierto todos los niveles del camino.",
        "a11y": "Progreso hacia el siguiente nivel"
      },
      "sources": {
        "title": "Fuentes de XP",
        "practices": "Prácticas",
        "lives": "Live",
        "media": "Medios",
        "comments": "Comentarios",
        "other": "Otros"
      },
      "recent": {
        "title": "Últimas concesiones",
        "description": "Aquí ves las actividades reales y la experiencia que te dieron."
      },
      "more": {
        "title": "Cómo ganar más",
        "description": "Practica, participa en Live, mira medios y comparte en los comentarios."
      }
    }
  },
  "levelInfo": {
    "title": "¿Qué es el nivel del camino espiritual?",
    "intro": "El nivel refleja tu progreso general en Agapella. Reúne Luz del Alma y abre nuevos escalones del camino.",
    "close": "Cerrar",
    "scrimA11y": "Cerrar la explicación del nivel del camino espiritual",
    "tabs": {
      "levels": "Niveles",
      "rewards": "Recompensas y posibilidades",
      "a11y": "Secciones de la explicación"
    },
    "levelNames": {
      "seeker": "Buscador",
      "keeper": "Guardián",
      "master": "Guía de Luz",
      "grand_master": "Maestro de Luz"
    },
    "current": {
      "eyebrow": "Nivel actual",
      "chip": "Actual",
      "xp": "{{xp}} XP",
      "unknown": "Tu escalón aún no está definido"
    },
    "next": {
      "toLevel": "Hasta el nivel «{{name}}» · {{remaining}} XP",
      "toLevelPlain": "Hasta el nivel «{{name}}»",
      "summitTitle": "Escalón más alto",
      "summitDescription": "Has recorrido todo el camino: a partir de aquí solo gana profundidad."
    },
    "progress": {
      "value": "{{percent}} %",
      "a11y": "Progreso hacia el siguiente nivel"
    },
    "ladder": {
      "title": "Escalera de niveles",
      "threshold": "{{xp}} XP",
      "state": {
        "passed": "Superado",
        "current": "Actual",
        "next": "Siguiente",
        "summit": "Escalón más alto",
        "future": "Por delante"
      }
    },
    "growth": {
      "title": "Cómo crece el nivel",
      "description": "El nivel crece junto con la Luz del Alma que acumulas. Sigue tu camino para abrir nuevos escalones."
    },
    "rewards": {
      "title": "Qué abre cada nivel",
      "items": {
        "seeker": {
          "1": "Acceso al Camino de la Luz.",
          "2": "Primeros logros.",
          "3": "Seguimiento de tu progreso personal."
        },
        "keeper": {
          "1": "La posibilidad de crear tu propia comunidad.",
          "2": "Nuevos logros y recompensas.",
          "3": "Participación en el desarrollo de las comunidades de Agapella."
        },
        "master": {
          "1": "Posibilidades ampliadas para realizar sesiones Live.",
          "2": "Gestión ampliada de tu propia comunidad.",
          "3": "Acceso a materiales y eventos especiales."
        },
        "grand_master": {
          "1": "La posibilidad de convertirte en asistente de un maestro.",
          "2": "La posibilidad de recibir permisos de moderación por invitación de un maestro o del dueño de una comunidad.",
          "3": "Participación en el desarrollo de la plataforma.",
          "4": "Eventos y recompensas especiales de Agapella."
        }
      }
    },
    "state": {
      "unavailable": "Los datos de progreso aún no se han cargado.",
      "retry": "Reintentar",
      "retryA11y": "Volver a cargar los datos del nivel"
    },
    "a11y": {
      "rung": "{{name}}. {{state}}",
      "rungWithXp": "{{name}}, {{xp}}. {{state}}"
    }
  },
  "personalRecordsInfo": {
    "title": "¿Qué son los Récords personales?",
    "intro": "Aquí se reúnen los cuatro indicadores de tu progreso en Agapella.",
    "close": "Cerrar",
    "scrimA11y": "Cerrar la explicación de los Récords personales",
    "banner": {
      "title": "Tu camino, a tu propio ritmo",
      "subtitle": "Cada paso cuenta"
    },
    "closing": "Estás en tu camino, y cada paso cuenta.",
    "xpUnit": "XP",
    "dayForms": {
      "one": "día",
      "few": "días",
      "many": "días"
    },
    "records": {
      "streak": {
        "title": "Racha más larga",
        "description": "La serie más larga de días seguidos con una práctica completada."
      },
      "practices": {
        "title": "Prácticas completadas",
        "description": "El número total de prácticas que has completado."
      },
      "lives": {
        "title": "Live a los que asististe",
        "description": "El número total de sesiones Live a las que te has unido."
      },
      "xp": {
        "title": "XP total",
        "description": "Tu cantidad actual de Luz del Alma (XP)."
      }
    },
    "a11y": {
      "row": "{{title}}: {{value}}. {{description}}",
      "unavailable": "valor no disponible"
    }
  },
  "milestonesInfo": {
    "title": "¿Qué son los Hitos del camino?",
    "intro": "Los Hitos del camino son los puntos importantes de tu Llama del Amor. Mantén tu racha de prácticas diarias para ir superándolos uno tras otro.",
    "close": "Cerrar",
    "scrimA11y": "Cerrar la explicación de los Hitos del camino",
    "listTitle": "Hitos del camino",
    "note": "Cada hito alcanzado abre el logro del mismo nombre. La insignia se suma a tu colección.",
    "days_one": "{{count}} día seguido",
    "days_other": "{{count}} días seguidos",
    "summary": {
      "currentStreak": "Racha actual",
      "nextMilestone": "Siguiente hito",
      "progress_one": "{{current}} de {{count}} día",
      "progress_other": "{{current}} de {{count}} días",
      "remaining_one": "Queda {{count}} día",
      "remaining_other": "Quedan {{count}} días",
      "allDone": "Todos los hitos superados",
      "allDoneDescription": "Has superado todos los hitos de la Llama del Amor. Mantén la racha: se queda contigo.",
      "unknownStreak": "La racha aún no se ha cargado"
    },
    "status": {
      "earned": "Conseguido",
      "inProgress": "En curso",
      "future": "Próximo"
    },
    "state": {
      "errorTitle": "No se han podido cargar los Hitos del camino",
      "errorMessage": "Inténtalo de nuevo.",
      "retry": "Reintentar",
      "retryA11y": "Volver a cargar los Hitos del camino",
      "stale": "Se muestran los últimos datos guardados",
      "loadingA11y": "Cargando los Hitos del camino"
    },
    "a11y": {
      "row": "{{name}}, {{days}}. {{status}}",
      "rowInProgress": "{{name}}, {{days}}. {{status}}, {{progress}}, {{remaining}}",
      "progressBar": "Progreso hacia el siguiente hito"
    }
  }
}
